import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable, Sort } from "@angular/material/sort";
import { MatTableDataSource } from '@angular/material/table';
import { AccountService, AlertService } from '@app/index';
import { FunctionsService } from '@app/_services/functions.service';
import { Case } from "@app/_models/case";
import { RestService } from '@app/_services/rest.service';
import { AppComponent } from '@app/app.component';
import { VClaim } from '@app/_models/vClaim';
import { VClaimsAll } from '@app/_models/vClaimsAll';
import { groups } from '@app/_services/auth-config';
@Component({
  selector: 'app-all-open-claims',
  templateUrl: './all-open-claims.component.html',
  styleUrls: ['./all-open-claims.component.scss']
})
export class AllOpenClaimsComponent implements OnInit {
  [x: string]: any;
  displayedColumns: string[] = ['caseNo', 'refNo', 'lastNameS', 'situationSuburb', 'recD', 'lastInspDate', 'sentReport', 'lastContact', 'contactDays',
    'isHoldContact', 'acceptance', 'peril', 'emergencyRepair', 'ecdEstimatedCompletionDate', 'originalStatus', 'reOpened'];
  dataSource!: MatTableDataSource<VClaimsAll>;
  isLoading = true;
  isHMAUser = true;
  pageIndex =1;
  pageSize =12;
  totalRecords =0;
  search = '';
  searchValue = localStorage.getItem('openClaimsSearchText') ? localStorage.getItem('openClaimsSearchText') : '';
  sortColumn = localStorage.getItem('openClaimsSortColumn') != null ? localStorage.getItem('openClaimsSortColumn') : 'refNo';
  sortDirection = localStorage.getItem('openClaimsSortDirection') != null ? localStorage.getItem('openClaimsSortDirection') : 'desc';

  userFullName = '';

  @ViewChild(MatSort, { static: true }) matSort!: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  constructor(private restService: RestService, private accountService: AccountService,
    private alertService: AlertService, public functionsService: FunctionsService, public appComponent: AppComponent) {
    this.userFullName = this.appComponent.getName();
  }

  async ngOnInit() {
    this.isHMAUser =
    this.appComponent.userGroupsArray.includes(groups.groupHMA);
    //if (this.accountService.isLoggedIn()) {
    await this.loadDataAsync();
    return;
    // }
    // else
    //   this.isLoading = false;
  }

  sortData(sort: Sort) {
    localStorage.setItem('openClaimsSortColumn', sort.active);
    localStorage.setItem('openClaimsSortDirection', sort.direction);
    // const data = this.desserts.slice();
    // if (!sort.active || sort.direction === '') {
    //   this.sortedData = data;
    return;
  }

  //Fetch latest claims from the REST API
  async loadDataAsync() {
    this.isLoading = true;
    var isAdminUser = false;
    let searchValue = this.searchValue !=null?this.searchValue:'';

    if (this.userFullName == 'Teresa Dunn' || this.userFullName == 'Jay Rupasinghe'|| this.userFullName == 'Jacob Towner' || this.userFullName == 'Steve Powney' || 
    this.userFullName == 'Noyola De Rose' || this.userFullName == 'Adrian Matias' || this.userFullName == 'Pears Chiramel' || this.userFullName == 'Hengke Zhu' || 
    this.userFullName == 'Prabesh Bajracharya')
      isAdminUser = true;

    await this.restService
      .getPagedVClaims(
        this.pageIndex,
        this.pageSize /*<= 3years & open*/,
        searchValue,
        this.accountService.clientFriendlyName,
        this.isHMAUser,
        true,
        '', 
        isAdminUser
      )
      .then((reponse) => {
        this.totalRecords = reponse?.totalCount;
        this.dataSource = new MatTableDataSource(reponse?.records);
        //this.totalCount = reponse?.totalCount ?? 0;
        this.dataSource.filter = JSON.parse(localStorage.getItem('claimSearchFilterState')!);
        this.searchValue = localStorage.getItem('openClaimsSearchText') ? localStorage.getItem('openClaimsSearchText') : '';

        if (this.searchValue != '' && this.searchValue != null) {
          this.dataSource.filter = this.searchValue;
        }
        else
          this.dataSource.filter = "";


        this.matSort.sort(({ id: this.sortColumn, start: this.sortDirection, disableClear: true }) as MatSortable);
        this.dataSource.sort = this.matSort;
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;
      });
  }

  //Reload the data from the database
  refreshData() {
    this.dataSource.data = [...this.dataSource.data];
    this.search = "";
    this.searchValue = '';
    this.paginator._changePageSize(12);
    this.matSort.sort(({ id: this.sortColumn, start: this.sortDirection, disableClear: true }) as MatSortable);
    this.dataSource.sort = this.matSort;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Filter claims by keyword
  onSearchKeyUp(search: { value: any; }) {
    if(this.searchValue!=search.value)
      {
    this.searchValue = search.value;
    localStorage.setItem('openClaimsFilterState', JSON.stringify(this.dataSource.filter));
    localStorage.setItem('openClaimsSearchText', search.value);
    this.loadDataAsync();
      }
  }


  //Clear filter claims by keyword
  onClearClicked(search: { value: string; }) {
    search.value = "";
    this.search = '';
    localStorage.setItem('openClaimsFilterState', '""');
    localStorage.setItem('openClaimsSearchText', '');
    if(this.searchValue !='')
      {
        this.searchValue =search.value;
        this.loadDataAsync();
      }

  }
  onPageSizeChange(event:any){
    this.pageSize=event.pageSize;
    this.pageIndex = event.pageIndex+1;
    this.loadDataAsync();
  }

  //Return the claim status - Active or Finalised
  /*getClaimStatus(bldCompletion: Date, ctsCompletion: Date) {
    if (bldCompletion == null || ctsCompletion == null) {
      return "Open";
    }
    else {
      return "Finalised";
    }
  }*/

  getClaimStatus(statusClaimTypeID: Number) {
    if (statusClaimTypeID == 1 || statusClaimTypeID == 3) {
      return 'Open';
    } else {
      return 'Finalised';
    }
  }
}
